module.exports = __webpack_public_path__ + "img/notice-period.b698395a.svg";